import InviteEarnService from '@/services/InviteEarnService'

export default {
  actions: {
    async fetchInviteOffers (ctx) {
      const inviteOffers = await InviteEarnService.methods.getOffers()
      ctx.commit('updateInviteOffers', inviteOffers.GetOffersResponse.OfferItems.OfferItem)
    }
  },
  mutations: {
    updateInviteOffers (state, inviteOffers) {
      state.inviteOffer = inviteOffers.find(e => !!e.IsInviteCode._text)
    }
  },
  getters: {
    getInviteOffer (state) {
      return state.inviteOffer
    }
  },
  state: {
    inviteOffer: null
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/inviteEarn.js